module.exports = __webpack_public_path__ + "static/portal-6ed162e677fd6bdeb34add895f021ea4.png";